import { useContext } from 'react';
import { useStore } from 'zustand';
import { LessonOverviewContext } from './NewLessonOverviewStoreProvider';
import { LessonOverviewContextStore } from './types';

const useLessonOverviewContext = <T>(
  selector: (state: LessonOverviewContextStore) => T,
  equalityFn?: (left: T, right: T) => boolean,
) => {
  const store = useContext(LessonOverviewContext);

  return useStore(store, selector, equalityFn);
};

export default useLessonOverviewContext;
